/* Hindustan Astro header panels: menu, contact and search (sections/c-header.liquid), 4 October 2026.
   Opening and closing stay in assets/c-app.js; this file only adds:
   1. Keyboard: when a panel opens, focus moves into it; Tab and Shift+Tab stay inside it while it is open;
      on close, focus goes back to the link or button that opened it.
   2. Smoothness: once an opened panel covers the whole screen (the menu and contact panels on phones and
      tablets), the page behind it cannot be seen, so its animations pause and the blur under the panel rests.
      Everything carries on in the same frame the panel starts to close, so nothing visible changes.
      The page gets html.cx-covered and a "cx:covered" event (detail true or false) for other scripts.
      19 October 2026: the pause marks only the elements that are animating at that moment (data-cxp, the rule is in
      sections/c-header.liquid). Before, one rule restyled every element of the page twice (on cover and on the close tap),
      which held up a frame while the menu items were still rising and delayed the start of the close. Same pause, same look. */
(function () {
  var D = document, H = D.documentElement, W = window;
  if (H._cxPanels) return; H._cxPanels = 1;
  var FOC = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var SEL = '[data-gm],[data-gc],[data-gs]';
  var open = null, timer = 0, mo = null;

  function items(p) {
    return [].filter.call(p.querySelectorAll(FOC), function (e) {
      return e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden';
    });
  }
  function focus(el) { try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (x) {} } }

  var ZONE = 'main, .shopify-section-group-c-footer-group, .shopify-section-group-footer-group', marked = [];
  function mark(on) {
    var i;
    if (!on) { for (i = 0; i < marked.length; i++) marked[i].removeAttribute('data-cxp'); marked = []; return; }
    if (!D.getAnimations) return;
    var as = D.getAnimations(), t;
    for (i = 0; i < as.length; i++) {
      if (as[i].playState !== 'running') continue;
      t = as[i].effect && as[i].effect.target;
      if (!t || !t.closest || t.hasAttribute('data-cxp') || !t.closest(ZONE)) continue;
      t.setAttribute('data-cxp', ''); marked.push(t);
    }
  }
  function cover(on) {
    if (H.classList.contains('cx-covered') === on) return;
    mark(on);
    H.classList.toggle('cx-covered', on);
    try { D.dispatchEvent(new CustomEvent('cx:covered', { detail: on })); } catch (e) {}
  }
  /* measured, not guessed: the panel must reach every edge of the screen. Only the menu and contact panels
     count: their size never changes while open. The search panel is left out because its height follows its
     results, so it can shrink while open (a cleared search) and show the page again with nothing to bring it back. */
  function check() {
    timer = 0;
    var el = open && open.querySelector('.gm__panel');
    if (!el) { cover(false); return; }
    var r = el.getBoundingClientRect();
    cover(r.left <= 0 && r.top <= 0 && r.right >= W.innerWidth && r.bottom >= W.innerHeight);
  }
  function later(ms) { clearTimeout(timer); timer = setTimeout(check, ms); }

  function opened(p) {
    open = p;
    var a = D.activeElement;
    if (!p.contains(a)) {
      p._cxBack = a && a !== D.body ? a : null;
      var first = items(p)[0]; if (first) focus(first);
    }
    cover(true);   /* the page behind rests from the first frame of the panel (20 October 2026) */
  }
  function closed(p) {
    if (open === p) { open = null; clearTimeout(timer); timer = 0; cover(false); }
    var a = D.activeElement, b = p._cxBack; p._cxBack = null;
    if (b && b.isConnected && b.getClientRects().length && (!a || a === D.body || p.contains(a))) focus(b);
  }

  function bind() {
    if (mo) mo.disconnect();
    /* theme editor: a reloaded header brings new, closed panels */
    if (open && !open.isConnected) { open = null; clearTimeout(timer); timer = 0; cover(false); }
    var ps = D.querySelectorAll(SEL); if (!ps.length || !W.MutationObserver) return;
    ps.forEach(function (p) { p._cxOn = p.classList.contains('is-open'); });
    mo = new MutationObserver(function (recs) {
      recs.forEach(function (r) {
        var p = r.target, on = p.classList.contains('is-open');
        if (on === p._cxOn) return;
        p._cxOn = on;
        if (on) opened(p); else closed(p);
      });
    });
    ps.forEach(function (p) { mo.observe(p, { attributes: true, attributeFilter: ['class'] }); });
  }
  bind();
  D.addEventListener('shopify:section:load', bind);

  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !open || e.defaultPrevented) return;
    var list = items(open); if (!list.length) return;
    var first = list[0], last = list[list.length - 1], a = D.activeElement;
    if (!open.contains(a)) { e.preventDefault(); focus(e.shiftKey ? last : first); }
    else if (e.shiftKey && a === first) { e.preventDefault(); focus(last); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); focus(first); }
  });

  /* a turned phone or a resized window: show everything at once, then measure again */
  W.addEventListener('resize', function () { if (open) cover(true); }, { passive: true });
})();
